export var SecurityCodeSendMethod;
(function (SecurityCodeSendMethod) {
    SecurityCodeSendMethod["Email"] = "Email";
    SecurityCodeSendMethod["SMS"] = "SMS";
})(SecurityCodeSendMethod || (SecurityCodeSendMethod = {}));
//# sourceMappingURL=SecurityCodeSendMethod.js.map